import React from 'react';
import { HiOutlineOfficeBuilding } from 'react-icons/hi';

interface OpportunitiesCardFooterProps {
	footerText: string;
	floor?: string;
	room?: string;
}

const OpportunitiesCardFooter: React.FC<OpportunitiesCardFooterProps> = ({ footerText, room, floor }) => {
	const assigned = !!(room && floor);
	return (
		<div className="flex items-center gap-3 rounded-b-[14px] border-t border-[#EEEEF5] bg-[#F7F7FB] px-4 py-3.5 md:px-6">
			<span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white text-[#4F46E5] shadow-[0_1px_2px_rgba(20,20,60,0.08)]">
				<HiOutlineOfficeBuilding className="h-[18px] w-[18px]" />
			</span>
			<span className={`text-[14px] leading-[20px] ${assigned ? 'font-[600] text-[#111E2C]' : 'text-[#6B6D85]'}`}>
				{assigned ? footerText : 'Room and floor not assigned yet'}
			</span>
		</div>
	);
};

export default OpportunitiesCardFooter;
